import {Injectable} from '@angular/core';
import {
  DataCoreService,
} from '@dabnet-kamu/libs/ui';
import {BehaviorSubject, } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TebDonemService {
  private tebDonemMap = new Map<string, BehaviorSubject<any[]>>();


  public getTebDonemList$(tabId: string) {
    if (!this.tebDonemMap.has(tabId)) {
      this.tebDonemMap.set(tabId, new BehaviorSubject<any[]>([]));
    }
    return this.tebDonemMap.get(tabId)!.asObservable();
  }

  constructor(
    private dataCoreService: DataCoreService
  ) {

  }


  async getTebDonemList(tabId: string, filter?: any[]) {
    if (!this.tebDonemMap.has(tabId)) {
      this.tebDonemMap.set(tabId, new BehaviorSubject<any[]>([]));
    }

    const dataSource = this.dataCoreService.getOData('TebDonem');
    dataSource.pageSize(50);
    dataSource.sort([{ selector: 'Yil', desc: true }]);
    if (filter) {
      dataSource.filter(filter);
    }

    try {
      await dataSource.load();
      const items = dataSource.items();
      this.tebDonemMap.get(tabId)!.next(items);
      return items;
    } catch (error) {
      throw error;
    }
  }

  clearTabDonem(tabId: string) {
    if (this.tebDonemMap.has(tabId)) {
      this.tebDonemMap.get(tabId)!.complete(); // subject tamamla
      this.tebDonemMap.delete(tabId);          // map’ten sil
    }
  }

  getTemDonemDataWithTebDonem(filters: { key: string, value: any }[]) {
    const dataSource = this.dataCoreService.getOData('TemDonem');

    dataSource.select();

    // Filtre dizisini dinamik olarak uyguluyoruz
    const filterArray = filters.map(filter => [filter.key, '=', filter.value]);

    // Birden fazla filtre ekleniyor
    dataSource.filter(filterArray);

    return dataSource;
  }



}
